import { connect } from 'react-redux'
import Page from './Page'
import { setLayout } from 'features/Layout/Layout.actions'
import { setAtTop } from 'components/Scroll/Scroll.actions'

const stateToProps = () => ({})

const dispatchToProps = {
  setLayout,
  setAtTop,
}

export default connect(stateToProps, dispatchToProps)(Page)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Page/Page.container.js